<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card widget-calendar">
                    <div class="p-3 card-body">
                        <div v-if="hasAutomaticReports" class="text-center mt-2">
                            <p><b>Tu reporte de horas está siendo generado automáticamente, no es necesario que captures
                                    horas</b></p>
                        </div>
                        <div v-if="closedPeriod" class="text-center mt-2">
                            <p><b>Este periodo de tiempo se encuentra cerrado, ya no puedes registrar horas</b></p>
                        </div>
                        <div v-if="!hasAutomaticReports"
                            class="d-flex flex-column flex-md-row justify-content-between mb-2">
                            <button class="btn btn-secondary ms-0" :disabled="closedPeriod"
                            @click="openModal(eventData.value, 'CreateEvent')">
                                + Registrar Evento</button>

                            <button v-if="showSendButton" :disabled="closedPeriod"
                            class="btn btn-warning ms-auto"
                                @click="sendToAuthorize()">Enviar a Autorizar</button>
                        </div>
                        <!-- Calendario -->
                        <div class="calendar-container position-relative">
                            <FullCalendar ref="calendarRef" :options="calendarOptions" />
                            <div v-if="isLocked" class="calendar-overlay"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData" @close="closeModal">
    </Modal>
    <div v-if="menuVisible" :style="menuStyle" class="floating-menu">
        <ul class="dropdown-menu show">
            <li><a class="dropdown-item" href="#" @click="handleEditClick(selectedEventId)">Editar</a></li>
            <li><a class="dropdown-item" href="#" @click="handleDeleteClick(selectedEventId)">Eliminar</a></li>
        </ul>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, shallowRef } from "vue";

import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

const calendarRef = ref(null)

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

import Modal from "./components/Modal.vue";
import CreateEvent from "./components/forms/CreateEvent.vue";
import EditEvent from "./components/forms/EditEvent.vue";

const formComponents = {
    CreateEvent: CreateEvent,
    EditEvent: EditEvent
}

const hasAutomaticReports = ref(false)

const weekStart = ref('')
const weekEnd = ref('')
const closedPeriod = ref(false)

const isLocked = ref(false)

const isModalOpen = ref(false);
const selectedFormComponent = shallowRef(null);
const modalTitle = ref("");
const selectedData = ref(null)

const showSendButton = ref(true)
const startDate = ref('')
const endDate = ref('')

const menuVisible = ref(false);
const menuStyle = ref({});
const selectedEventId = ref(null);

const showMenu = (event, eventId) => {
    selectedEventId.value = eventId;
    menuVisible.value = true;

    // Calcula el ancho del menú (aproximadamente 150px)
    const menuWidth = 100;
    let leftPosition = event.clientX - menuWidth; // Restamos el ancho para moverlo a la izquierda

    // Evita que el menú se salga de la pantalla
    if (leftPosition < 0) leftPosition = 50;

    // Calcula la posición del menú basado en la posición del clic
    menuStyle.value = {
        position: "fixed",
        top: `${event.clientY}px`,
        left: `${leftPosition}px`,
        zIndex: 9999,
    };
};

const hideMenu = () => {
    menuVisible.value = false;
};

// Función para abrir el modal con un formulario y datos específicos
const openModal = (data, formType) => {
    selectedData.value = data || {}; // Si no se pasa nada, se inicializa como objeto vacío
    selectedFormComponent.value = formComponents[formType] || null;

    // Asignar título dinámico
    const titles = {
        CreateEvent: "Registrar Evento",
        EditEvent: "Editar Evento",
    };
    modalTitle.value = titles[formType] || "Editar Información";
    isModalOpen.value = true;
    hideMenu();
};

const closeModal = () => {
    isModalOpen.value = false;
};

// Formatear hora
const formatTime = (date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

// Manejar selección de fecha
const handleDateClick = (info) => {
    const clickedDate = new Date(info.dateStr);
    eventData.value.date = clickedDate.toLocaleDateString('sv-SE');
    let startTime = clickedDate.getHours();
    let startMinutes = clickedDate.getMinutes();
    eventData.value.start_time = `${startTime.toString().padStart(2, '0')}:${startMinutes.toString().padStart(2, '0')}`;
    clickedDate.setMinutes(clickedDate.getMinutes() + 30);
    let endTime = clickedDate.getHours();
    let endMinutes = clickedDate.getMinutes();
    eventData.value.end_time = `${endTime.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;
    openModal(eventData.value, 'CreateEvent');
};

// Manejar selección de rango de fechas
const handleDateSelect = (info) => {
    const startDate = new Date(info.startStr);
    const endDate = new Date(info.endStr);
    eventData.value.date = startDate.toLocaleDateString('sv-SE');
    eventData.value.start_time = formatTime(startDate);
    eventData.value.end_time = formatTime(endDate);
    openModal(eventData.value, 'CreateEvent');
};

const eventData = ref({
    date: '',
    start_time: '',
    end_time: '',
    is_billable: false,
    is_extra_time: false,
    on_site: false,
    client_id: null,
    project_id: null,
    activity_id: '',
    notes: '',
});

const checkview = (calendarApi) => {
    const view = calendarApi.view;

    // Validar si estás en vista semanal
    if (view.type.includes('Week')) {
        const monday = new Date(view.currentStart);
        const sunday = new Date(view.currentEnd);
        monday.setDate(monday.getDate())
        sunday.setDate(sunday.getDate() - 1);

        startDate.value = monday.toISOString().split('T')[0];
        endDate.value = sunday.toISOString().split('T')[0];

        showSendButton.value = true

    } else {
        showSendButton.value = false
    }

}


const calendarOptions = ref({
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    initialView: "timeGridWeek",
    firstDay: 1,
    datesSet(info) {

        weekStart.value = formatDateUTC(info.startStr)

        // Fin de la semana (UTC) → restar un día completo
        const adjustedEnd = new Date(info.end);
        adjustedEnd.setUTCDate(adjustedEnd.getUTCDate() - 1);

        weekEnd.value = formatDateUTC(adjustedEnd);

        verifyIsLocked()

        const calendarApi = calendarRef.value.getApi();
        checkview(calendarApi);
    },
    buttonText: {
        today: 'Hoy',
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
        list: 'Lista'
    },
    headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay",
    },
    scrollTime: '08:00:00',
    locale: 'es',
    events: [],
    editable: false,
    selectable: !hasAutomaticReports.value,
    select: !hasAutomaticReports.value ? handleDateSelect : null,
    dateClick: !hasAutomaticReports.value ? handleDateClick : null,
    eventContent: function (arg) {

        const isAuth = arg.event.extendedProps.is_auth;
        const isExtra = arg.event.extendedProps.is_extra_time;
        const isSent = arg.event.extendedProps.sent;

        const content = `
    <div class="d-flex flex-column h-100 w-100 p-1 text-break"
        style="overflow: auto; scrollbar-width: thin; scrollbar-color: transparent transparent; background-color: transparent;">
        <style>
        .fc-event .scrollable-content::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        .fc-event .scrollable-content::-webkit-scrollbar-thumb {
            background-color: transparent;
        }
        .fc-event .scrollable-content::-webkit-scrollbar-track {
            background-color: transparent;
        }
        </style>
        <div class="d-flex justify-content-between align-items-start w-100 scrollable-content">
            <div class="flex-grow-1 small">
                <strong> ${isExtra ? '| TIEMPO EXTRA |' : ''} </strong>${arg.event.title}<strong>${isSent ? '| ENVIADO |' : ''} ${isAuth ? ' AUTORIZADO |</strong>' : ''}
            </div>
            ${(isSent === false && isAuth === false) ? `
                <button class="btn btn-sm btn-link p-0 ms-1 event-menu-btn text-light"
                        data-event-id="${arg.event.id}" title="Opciones" style="font-size: 1.5em;">
                    ⋮
                </button>` : ''
            }
        </div>
    </div>
`;
        return { html: content };
    },
    eventDidMount: function (info) {
        const menuBtn = info.el.querySelector('.event-menu-btn');
        if (menuBtn) {
            menuBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                showMenu(e, info.event.id);
            });
        }
    }


});

const handleEditClick = (eventId) => {
    selectedData.value = {
        time_record_id: eventId
    };
    openModal(selectedData.value, 'EditEvent');
};


const handleDeleteClick = async (eventId) => {
    hideMenu();
    if (confirm('¿Estás seguro de eliminar este evento?')) {
        try {
            const response = await axios.post(`${API_BASE_URL}/remove-time-record`, {
                time_record_id: eventId
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                alert('Registro Eliminado');
                loadEvents(); // Recargar eventos después de eliminar
            }
        } catch (error) {
            console.error('Error al registrar la actividad:', error);
            // Verificar si hay respuesta del servidor
            if (error.response) {
                alert(error.response.data.msg || 'Ocurrió un error al registrar el evento.');
                window.location.reload()
            } else {
                alert('Error de conexión con el servidor.');
            }
        }
    }
};



const sendToAuthorize = async () => {

    if (confirm('¿Estás seguro de enviar a revisión para autorizar tu semana completa? Esta acción NO puede deshacerse')) {
        const body = { start_date: startDate.value, end_date: endDate.value }

        try {
            const events_response = await axios.post(`${API_BASE_URL}/validate-week`, body, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            alert(events_response.data.msg)
            window.location.reload()
        } catch (error) {
            // Verificar si hay respuesta del servidor
            if (error.response) {
                alert(error.response.data.msg || 'Ocurrió un error al enviar a autorización.');
            } else {
                alert('Error de conexión con el servidor.');
            }
        }
    }

}


const loadEvents = async () => {

    calendarOptions.value.events = []; //Limpiar arreglo de Eventos en Calendar Options

    try {
        const events_response = await axios.post(`${API_BASE_URL}/user-event-data`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        const userEventData = events_response.data

        // Iteramos sobre cada evento en el array
        userEventData.forEach(event => {
            const newStart = new Date(event.date + 'T' + event.start_time);
            const newEnd = new Date(event.date + 'T' + event.end_time);
            if (event.color_code == null || event.color_code == '') { event.color_code = '#9e9d9d' }
            // Agregamos cada evento formateado al calendario
            calendarOptions.value.events.push({
                id: event.time_record_id,
                title: `${event.client} | ${event.activity} | ${event.notes}`,
                start: newStart.toISOString(),
                end: newEnd.toISOString(),
                backgroundColor: event.color_code,
                borderColor: '#0000',
                textColor: '#FFFFFF',
                is_auth: event.is_auth,
                is_extra_time: event.is_extra_time,
                sent: event.sent
            });
        });


    } catch (error) {
        alert('Error al obtener los eventos')
        console.error('Error al obtener los eventos', error);
    }

}

const checkHasAutomaticReports = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/check-user-ar-status`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        hasAutomaticReports.value = response.data.has_automatic_reports
    } catch (error) {
        // Verificar si hay respuesta del servidor
        if (error.response) {
            console.error(error.response)
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
}

const formatDateUTC = (date) => {
    // Si 'date' no es un objeto Date, lo convertimos
    const utcDate = (date instanceof Date) ? date : new Date(date);
    const year = utcDate.getUTCFullYear();
    const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(utcDate.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};


const handleClickOutside = (event) => {
    if (menuVisible.value && !event.target.closest('.floating-menu')) {
        hideMenu();
    }
};

const verifyIsLocked = async () => {

    const body = {
        start_date: weekStart.value,
        end_date: weekEnd.value
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/verify-locked-week`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });

        closedPeriod.value = false
        isLocked.value = false

        if(response.data.is_locked > 0){
            closedPeriod.value = true
            isLocked.value = true
        }

    } catch (error) {
        // Verificar si hay respuesta del servidor
        if (error.response) {
            console.error(error.response)
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
}

// Cargar clientes al montar el componente
onMounted(() => {
    checkHasAutomaticReports();
    verifyIsLocked();
    loadEvents();
    checkview(calendarRef.value.getApi())
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});

</script>

<style scoped>
/* Asegurar que el dropdown esté siempre por encima */
.dropdown-menu {
    z-index: 1051 !important;
    /* Bootstrap usa 1050 para modals, así que subimos */
    position: absolute !important;
    display: block;
}

/* Asegurar que los eventos no tapen el dropdown */
.fc .fc-event {
    z-index: 1000 !important;
    /* Menor que el dropdown */
    position: relative !important;
    overflow: visible !important;
}

.dropdown-item {
    cursor: pointer;
}

.calendar-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 95%;
    background: rgba(255, 255, 255, 0.5);
    /* capa translúcida */
    z-index: 10;
    cursor: not-allowed;
}
</style>